<template>
  <div class="list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="入驻申请记录" name="first">
        <apply :tableData="applyData"></apply>
      </el-tab-pane>
      <el-tab-pane label="资料变更记录" name="second">
        <alter :tableData="alterData"></alter>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Apply from "./components/apply";
import Alter from "./components/alteration";
import { checkRecord } from "common/js/api";

export default {
  components: {
    Apply,
    Alter
  },

  data() {
    return {
      activeName: "first",
      applyData: [],
      alterData: [],
      userCode: ""
    };
  },

  created() {
   
    // this.userCode = 'JG472462'
  },

  mounted() {
  },

  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    }
  }
};
</script>
<style lang="scss">
.el-tabs{
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-tabs__content{
    flex:1 1 auto;
    .el-tab-pane{
      height: 100%;
      overflow: auto;
      .apply{
        height: 100%;
        .table-item{
          height: calc(100% - 74px);
        }
      }
    }
  }
}
.el-tabs__item{
  color:#6C7885 !important;
}
.el-menu-demo .el-menu-item{
  border-bottom-color:#3165FF !important;
}
.el-tabs__active-bar{
  background-color:#3165FF !important;
}
</style>
<style lang="scss" scoped>
::v-deep .type-title::before{
  display: none;
}
.list {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 12px 0px #cccccc80;
  height: 100%;
  display: flex;
  overflow: auto;
  flex-direction: column;
  padding: 20px;
  > .table {
    flex: 1;
  }
}
::v-deep .table-item .table{
  height: calc(100% - 20px);
}
</style>

